import React from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { TestimonialsSection } from './components/Testimonials';
import { PainPoints } from './components/PainPoints';
import { ProductSection } from './components/ProductSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ResetSection } from './components/ResetSection';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostTable } from './components/CostTable';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-brand-dark text-white font-sans selection:bg-brand-light selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <SocialProofPopup data-id="element-2" />
      <Hero data-id="element-3" />
      <StatsBar data-id="element-4" />
      <TestimonialsSection data-id="element-5" />
      <PainPoints data-id="element-6" />
      <ProductSection data-id="element-7" />
      <BonusSection data-id="element-8" />
      <PricingSection data-id="element-9" />
      <ResetSection data-id="element-10" />

      {/* More Testimonials before Guarantee */}
      <section className="py-12 md:py-20 bg-brand-dark border-t border-gray-800" data-id="element-11">
        <div className="container mx-auto px-4" data-id="element-12">
          <div className="text-center mb-6 md:mb-12" data-id="element-13">
            <h2 className="text-2xl md:text-3xl font-bold text-brand-light font-[Poppins,_sans-serif]" data-id="element-14">
              ❤️ LO QUE DICEN LAS QUE YA LO TIENEN
            </h2>
          </div>
          <div className="flex flex-col gap-6 md:grid md:grid-cols-2 md:gap-6 max-w-5xl mx-auto" data-id="element-15">
            {[{
            initials: 'MG',
            name: 'María G.',
            location: '📍 Tucumán',
            quote: '"Años sin poder estar tranquila en una mesa. Hoy fui al cumpleaños de mi nieta y no pensé en mi panza ni una sola vez."'
          }, {
            initials: 'LP',
            name: 'Laura P.',
            location: '📍 Buenos Aires',
            quote: '"No era la comida. Era mi sistema nervioso. Ahora tengo cómo apagarlo. Cambió todo."'
          }, {
            initials: 'NP',
            name: 'Natalia P.',
            location: '📍 Rosario',
            quote: '"Una cesárea de hace 26 años que tenía que ver con los gases del lado derecho. Cuando trabajé la adherencia, el gas empezó a moverse. No lo podía creer."'
          }, {
            initials: 'LR',
            name: 'Laura R.',
            location: '📍 Mar del Plata',
            quote: '"A los 63 pensé que era tarde. Me equivoqué. En dos semanas desapareció la pesadez y el miedo después de cada comida."'
          }].map((t, i) => <div key={i} className="flex flex-col" data-id="element-16">
                <div className="flex items-center gap-3 mb-2" data-id="element-17">
                  <div className="w-10 h-10 rounded-full bg-brand-dark border-2 border-brand-green/40 flex items-center justify-center text-brand-light font-bold text-sm shrink-0" data-id="element-18">
                    {t.initials}
                  </div>
                  <div data-id="element-19">
                    <div className="text-yellow-400 text-sm leading-none mb-0.5" data-id="element-20">
                      ★★★★★
                    </div>
                    <div className="font-bold text-white text-sm" data-id="element-21">{t.name}</div>
                    <div className="text-xs text-gray-400" data-id="element-22">{t.location}</div>
                  </div>
                </div>
                <p className="text-gray-300 italic text-sm leading-relaxed pl-0" data-id="element-23">
                  {t.quote}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      <Guarantee data-id="element-24" />
      <FAQ data-id="element-25" />
      <CostTable data-id="element-26" />

      {/* Final CTA Section (Reusing Pricing) */}
      <div className="bg-brand-black border-t border-brand-green/20" data-id="element-27">
        <PricingSection data-id="element-28" />
      </div>

      <Footer data-id="element-29" />
    </div>;
}